import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Text, Icon } from 'atoms';
import { colorShade } from 'utils';

const template = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #E3E3E3;
    text-align: center;
    cursor: ${displayState?.allowEdit ? 'pointer' : ''};
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 1px;
    padding-left: 4px;
    padding-right: 4px;
    height: 100%;
    width: 100%;
    white-space: nowrap;
    color: ${displayState?.selected ? window?.settings?.primary_color ?? '#1DBD6B' : '#9EACB0'};
    background: ${displayState?.selected ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : ''};

    svg {
      fill: ${displayState?.selected ? window?.settings?.primary_color ?? '#1DBD6B' : '#9EACB0'};
      margin-right: 3px;
    }


    @media (min-width: 768px) {
      font-size: 14px;
      padding-left: 10px;
      padding-right: 10px;
      svg {
        margin-right: 5px;
      }

      &:hover {
      background: ${displayState?.allowEdit ? colorShade(0.9, window?.settings?.primary_color ?? '#1DBD6B') : ''};
      color: ${displayState?.allowEdit ? window?.settings?.primary_color ?? '#1DBD6B' : ''};
      svg {
        fill: ${displayState?.allowEdit ? window?.settings?.primary_color ?? '#1DBD6B' : ''};
      }
    }
    } 
  `}
`;

export default Molecule({
  template,
  type: 'button',
  atoms: [
    {
      component: Icon,
      name: 'Icon',
      renderIf: ({ icon }) => !!icon,
      displayValue: ({ icon }) => icon
    },
    {
      component: Text,
      name: 'Text',
      displayValue: ({ text }) => text
    }
  ]
})